export const build = { date:"2026-06-03.1253", stage:"alpha" }
